import { useHistory } from "react-router-dom";

const PageNotFoundPage = () => {
  const history = useHistory();
  return (
    <div className="page-not-found-container">
      <div className="page-not-found-content">
        <p className="status-not-found text-center">404</p>
        <p className="page-not-found-heading text-center">Page Not Found</p>
        <div className="d-flex flex-direction-r gap-10 mg-top-10">
          <button className="saveBtn1" onClick={() => history.push("/login")}>
            Login
          </button>
          <button className="saveBtn1" onClick={() => history.push("/")}>
            Back To Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default PageNotFoundPage;
